<template>
    <div class="container">
        <div class="kt-portlet">
            <div class="kt-portlet__body">
                <div class="kt-section">
                    <div class="kt-section__content">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>Nº orden</th>
                                    <th>Fecha de compra</th>
                                    <th>Detalle de compra</th>
                                    <th class="text-right">Total</th>
                                    <th class="text-center">Estado</th>
                                    <th class="text-center">Acciones</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="cargando">
                                    <tr>
                                        <td colspan="7" class="text-muted text-center">
                                            <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i> Cargando
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr v-for="(i,ii) in lista" :key="ii">
                                        <th scope="row">{{i.dt9}}</th>
                                        <td>{{fechaLarga(i.ddt2)}}</td>
                                        <td>
                                            <span>{{i.dt4}}</span>
                                            <small>{{i.dt1}}</small>
                                            <small v-for="j in i.elements" :key="j.dt1" class="text-muted">{{j.dt2}}</small>
                                            <small v-for="j in i.elements2" :key="j.dt1" class="text-muted">{{j.dt2}}</small>
                                        </td>
                                        <td class="precio-syb text-right">{{punto(i.ndt9)}}</td>
                                        <td class="text-center">
                                            <span class="badge" :class="colorStado(i)">{{i.dt10}}</span>
                                        </td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-primary btn-elevate btn-pill btn-sm" v-on:click="irDetalle(i)">Ver detalle de Compra</button>
                                        </td>
                                    </tr>
                                    <tr v-if="lista.length===0">
                                        <td colspan="7" class="text-muted text-center">
                                            No existen registros
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {negociacion} from "../../servicios";
    import constantes from "../../constantes";
    export default {
        name: "compras",
        data:()=>({
            lista:[],
            cargando:true,
        }),
        methods:{
            fechaLarga:(fechaIso)=>constantes.funciones.formatoFechaL(fechaIso),
            punto:(n)=>constantes.funciones.puntoMilesDecimal(n),
            colorStado:(obj)=>constantes.funciones.colorEstado(obj.dt10),
            consultaContado:function(){
                this.cargando=true;
                negociacion.listaPorTipo(1).then(r=>r.data).then(response=>{
                    this.lista=response;
                    this.cargando=false;
                });
            },
            irDetalle:function(i){
                this.$store.commit('setCotizacion',i);
                this.$router.push({ name: 'compras.detalle' });
            }
        },
        mounted() {
            this.consultaContado();
        }
    }
</script>

<style scoped>
    td small {
        display: block;
    }
</style>
